import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Text, Button, Base } from '@brandwatch/axiom-components';

import './SlideChaser.css';

function EnterpriseLogo() {
  const height = 1.8;
  const viewBoxWidth = 150;
  const viewBoxHeight = 30;
  const viewBoxAspectRatio = viewBoxWidth / viewBoxHeight;

  const style = {
    width: `${(height * viewBoxAspectRatio)}rem`,
    height: `${height}rem`,
  };

  return (
    <Fragment>
      <Base className="ax-logo" style={style}>
        <img src="https://cdn.vizia.brandwatch.com/assets/theme-logos/logo-horizontal.svg" style={style} />
      </Base>
    </Fragment>
  );
}

function SelfserveLogo() {
  return (
    <Fragment>
      <Text textCase="upper" textStrong textSize="headtitle">
        Vizia
      </Text>
      <Text
        textCase="upper"
        textStrong
        textColor="ui-accent"
        textSize="headtitle"
      >
        .io
      </Text>
    </Fragment>
  );
}

function EnterpriseCopy() {
  return (
    <Fragment>
      <Text textSize="body" textCase="capital">
        Learn more about Vizia
      </Text>
    </Fragment>
  );
}

function SelfserveCopy() {
  return (
    <Fragment>
      <Text textSize="body" textCase="capital">
        Join Vizia for free
      </Text>
    </Fragment>
  );
}

function SlideChaser({ clientType }) {
  const selfserveUrl = 'https://www.vizia.io/p/refer/';
  const enterpriseUrl =
    'https://www.brandwatch.com/demo/speak-to-a-vizia-expert/';

  const onClick = useCallback(
    () =>
      window.open(
        clientType === 'enterprise' ? enterpriseUrl : selfserveUrl,
        '_blank',
        'noopener'
      ),
    [clientType]
  );

  if (!clientType) {
    return null;
  }

  return (
    <div className="SlideChaser__container">
      <div className="SlideChaser__title">
        {clientType === 'enterprise' && <EnterpriseLogo />}
        {clientType === 'self_serve' && <SelfserveLogo />}
      </div>
      <div className="SlideChaser__button">
        <Button style="quaternary" size="medium" onClick={onClick}>
          {clientType === 'enterprise' && <EnterpriseCopy />}
          {clientType === 'self_serve' && <SelfserveCopy />}
        </Button>
      </div>
    </div>
  );
}

SlideChaser.propTypes = {
  clientType: PropTypes.string
};

export default SlideChaser;
